module.exports = __webpack_public_path__ + "img/744.10fb89d7.jpg";